import { Controller } from "@hotwired/stimulus"

// Master-detail list on the authorised accounts page: clicking an account shows
// its details alongside.
export default class extends Controller {
  static targets = ["account", "detail"]

  connect() {
    this.show(0)
  }

  select(event) {
    this.show(parseInt(event.currentTarget.dataset.index))
  }

  show(index) {
    this.detailTargets.forEach((detail, i) => detail.classList.toggle("hidden", i !== index))
    this.accountTargets.forEach((account, i) => account.classList.toggle("bg-gray-100", i === index))
  }
}
